import { useEffect, useRef } from 'react';
import Centrifuge from 'centrifuge';


export function useSocketFeed(isActive, tokens, onMessage) {
  const centrifugeRef = useRef(null);
  const subscriptionsRef = useRef([]);

  // Connection management
  useEffect(() => {
    if (!isActive) {
      if (centrifugeRef.current) {
        centrifugeRef.current.disconnect();
        centrifugeRef.current = null;
      }
      return;
    }

    const centrifuge = new Centrifuge(import.meta.env.VITE_API_FEED);
    centrifuge.connect();
    centrifugeRef.current = centrifuge;

    return () => {
      if (centrifugeRef.current) {
        centrifugeRef.current.disconnect();
        centrifugeRef.current = null;
      }
    };
  }, [isActive]);

  // Subscription management
  useEffect(() => {
    const cen = centrifugeRef.current;
    if (!isActive || !cen || !tokens?.length) {
        subscriptionsRef.current.forEach(s => s.unsubscribe());
        subscriptionsRef.current = [];
        return;
    }

    // Cleanup previous subs
    subscriptionsRef.current.forEach(s => s.unsubscribe());
    subscriptionsRef.current = [];

    const tagsToReplace = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
    const sanitize = (str) => str.replace(/[&<>]/g, (t) => tagsToReplace[t] || t);

    const subs = tokens.map(token => {
      const sub = cen.subscribe(String(token), (message) => {
        try {
          const raw = JSON.stringify(message);
          const tickData = JSON.parse(sanitize(raw))?.data;
          if (tickData) {
            onMessage(String(token), tickData);
          }
        } catch (err) { /* ignore */ }
      });
      return sub;
    });

    subscriptionsRef.current = subs;

    return () => {
      subs.forEach(s => s.unsubscribe());
      subscriptionsRef.current = [];
    };
  }, [isActive, tokens, onMessage]);
}
